import type { TRuleWithTheme } from '@/styles/theme';

export const titleContainer: TRuleWithTheme<{ divider: boolean }> = ({ theme, divider }) => ({
    paddingTop: '1rem',
    paddingRight: '1.5rem',
    paddingBottom: '1.125rem',
    paddingLeft: '1.5rem',

    extend: {
        condition: divider,
        style: {
            borderBottomWidth: 1,
            borderBottomStyle: 'solid',
            borderBottomColor: theme.colors.foregroundsSeparator,
        },
    },

    min1440: {
        paddingTop: '3.75rem',
    },
});

export const titleRow: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
});

export const title: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
});

export const description: TRuleWithTheme = () => ({
    paddingTop: '0.75rem',
    paddingBottom: '0.25rem',
});

export const container: TRuleWithTheme = ({ theme }) => ({
    flex: 1,

    overflow: 'auto',

    display: 'flex',
    flexDirection: 'column',

    // Owned here rather than inherited from MainSection, which only paints white for the legacy
    // split-layout routes — a full-width settings page would otherwise sit on the app background.
    backgroundColor: theme.colors.white,
});

export const link: TRuleWithTheme = () => ({
    display: 'flex',

    marginRight: '0.5rem',

    transform: 'rotate(90deg)',
});

export const wrapper: TRuleWithTheme = () => ({
    overflow: 'auto',
});
